var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleAttention(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_838_1297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.27772 14.6673C7.40208 14.6685 6.53484 14.4965 5.72586 14.1614C4.91687 13.8263 4.18208 13.3346 3.56373 12.7147C2.94374 12.0963 2.45206 11.3615 2.11695 10.5525C1.78185 9.74354 1.60992 8.8763 1.61106 8.00066C1.60994 7.12501 1.78188 6.25778 2.11698 5.4488C2.45208 4.63981 2.94375 3.90503 3.56373 3.28666C4.18208 2.66667 4.91687 2.17499 5.72586 1.83989C6.53484 1.50478 7.40208 1.33286 8.27772 1.33399C9.15337 1.33287 10.0206 1.50481 10.8296 1.83991C11.6386 2.17501 12.3734 2.66668 12.9917 3.28666C13.6117 3.90503 14.1034 4.63981 14.4385 5.4488C14.7736 6.25778 14.9455 7.12501 14.9444 8.00066C14.9455 8.8763 14.7736 9.74354 14.4385 10.5525C14.1034 11.3615 13.6117 12.0963 12.9917 12.7147C12.3734 13.3346 11.6386 13.8263 10.8296 14.1614C10.0206 14.4965 9.15337 14.6684 8.27772 14.6673V14.6673Z",
    stroke: "#CF0000",
    strokeWidth: 1.33333,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27775 12.3346C8.05674 12.3346 7.84478 12.2468 7.6885 12.0906C7.53221 11.9343 7.44442 11.7223 7.44442 11.5013C7.44442 11.2803 7.53221 11.0683 7.6885 10.912C7.84478 10.7558 8.05674 10.668 8.27775 10.668C8.49876 10.668 8.71073 10.7558 8.86701 10.912C9.02329 11.0683 9.11108 11.2803 9.11108 11.5013C9.11108 11.7223 9.02329 11.9343 8.86701 12.0906C8.71073 12.2468 8.49876 12.3346 8.27775 12.3346Z",
    fill: "#CF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27771 4V9.33333",
    stroke: "#CF0000",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_838_1297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 16.2781 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleAttention);
export default __webpack_public_path__ + "static/media/CircleAttention.42c3a4be4ed4a7626a55d0c5853e3c20.svg";
export { ForwardRef as ReactComponent };